import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIService } from 'src/api/api';
import { updateItemInArray } from 'src/utils/getInitials';

const initialState = {
  tyreList: [],
  allTyres: [],
  totalCount: 0,
  tyreDetails: {},
  loading: false,
};

export const getTyreList = createAsyncThunk(
  'tyres/list', async (req, { rejectWithValue }) => {
    const { limit, pageNo, params } = req;
    try {
      const res = await APIService.getTyreList(limit, pageNo, params);
      if (!res.success) throw res;
      return res.result;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const loadMoreTyreList = createAsyncThunk(
  'tyres/list/loadmore', async (req, { rejectWithValue }) => {
    const { limit, pageNo, params } = req;
    try {
      const res = await APIService.getTyreList(limit, pageNo, params);
      if (!res.success) throw res;
      return res.result;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getAllTyres = createAsyncThunk(
  'tyres/all', async (_, { rejectWithValue }) => {
    try {
      const res = await APIService.getTyreList(1000, 1);
      if (!res.success) throw res;
      return res.result?.results || [];
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getTyreDetails = createAsyncThunk(
  'tyre/details', async (id, { rejectWithValue }) => {
    try {
      const res = await APIService.getTyreDetails(id);
      if (!res.success) throw res;
      return res.result;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const updateTyreDetails = createAsyncThunk(
  'tyres/updateDetails', async (data, { rejectWithValue }) => {
    try {
      const res = await APIService.updateTyreDetails(data.id, data);
      if (!res.success) throw res;
      return { ...data, ...res.result };
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const addNewTyre = createAsyncThunk(
  'sites/create', async (data, { rejectWithValue },) => {
    try {
      const res = await APIService.createTyre(data);
      if (!res.success) throw res;
      return res.result;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const tyreSlice = createSlice({
  name: 'tyres',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // add your async reducers here
    builder
      .addCase(getAllTyres.fulfilled, (state, action) => ({ ...state, allTyres: action.payload }))
      .addCase(getTyreList.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        totalCount: action.payload.count,
        tyreList: action.payload.results
      }))
      .addCase(getTyreList.pending, (state) => ({ ...state, loading: true }))
      .addCase(getTyreList.rejected, (state) => ({ ...state, loading: false }))
      .addCase(loadMoreTyreList.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        totalCount: action.payload.count,
        tyreList: [...state.tyreList, ...action.payload.results]
      }))
      .addCase(loadMoreTyreList.pending, (state) => ({ ...state, loading: true }))
      .addCase(loadMoreTyreList.rejected, (state) => ({ ...state, loading: false }))
      .addCase(getTyreDetails.fulfilled, (state, action) => ({ ...state, loading: false, tyreDetails: action.payload }))
      .addCase(getTyreDetails.pending, (state) => ({ ...state, loading: true }))
      .addCase(getTyreDetails.rejected, (state) => ({ ...state, loading: false }))
      .addCase(updateTyreDetails.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        tyreDetails: action.payload,
        tyreList: updateItemInArray(state.tyreList, action.payload)
      }))
      .addCase(addNewTyre.fulfilled, (state, action) => {
        state.tyreList.push(action.payload);
      });
  }
});

export default tyreSlice.reducer;
